import { useContext } from "react"
import { AppContext } from "../App"
import { MdAccountCircle, MdHistory, MdLibraryBooks, MdLogout } from "react-icons/md"

export default function AccountDashboard() {

  const appContext = useContext(AppContext);
  const userData = appContext.currentUserData;

  return (
    <div className="customer-dashboard">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
        <div>
          <span className="marketplace-eyebrow text-primary">CUSTOMER DASHBOARD</span>
          <h6 className="section-title mb-0">
            {userData?.fullname || userData?.phone || 'My Account'}
          </h6>
        </div>

        <button className="btn btn-outline-primary btn-rounded" onClick={appContext.logOut}>
          Logout <MdLogout size={20}/>
        </button>
      </div>

      <div className="row g-4">
        <div className="col-12 col-lg-4">
          <div className="card customer-dashboard-card h-100">
            <div className="card-body">
              <div className="customer-dashboard-icon">
                <MdAccountCircle size={34}/>
              </div>
              <h6>My Account</h6>
              <p>View your profile and manage your customer account details.</p>

              <div className="customer-profile-preview">
                <p><span>Full Name</span>{userData?.fullname || 'Not added yet'}</p>
                <p><span>Phone</span>{userData?.phone || 'Not added yet'}</p>
                <p><span>Email</span>{userData?.email || 'Not added yet'}</p>
              </div>

              <button className="btn btn-primary btn-rounded" disabled>
                Manage Account
              </button>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4">
          <div className="card customer-dashboard-card h-100">
            <div className="card-body">
              <div className="customer-dashboard-icon">
                <MdLibraryBooks size={34}/>
              </div>
              <h6>Purchased Access</h6>
              <p>
                Open all books, videos, journals and stories that you have successfully purchased.
              </p>

              <div className="marketplace-empty-state customer-library-placeholder">
                Your purchased content is securely available from this section.
              </div>

              <button
                className="btn btn-primary btn-rounded"
                onClick={() => appContext.navTo({ item: 'account', subItem: 'purchased-access' })}
              >
                Open Purchased Access
              </button>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4">
          <div className="card customer-dashboard-card h-100">
            <div className="card-body">
              <div className="customer-dashboard-icon">
                <MdHistory size={34}/>
              </div>
              <h6>Order History</h6>
              <p>
                Review paid, pending and cancelled orders, and retry active pending payment requests.
              </p>

              <div className="marketplace-empty-state customer-library-placeholder">
                Track your complete payment and order activity from this section.
              </div>

              <button
                className="btn btn-primary btn-rounded"
                onClick={() => appContext.navTo({ item: 'account', subItem: 'order-history' })}
              >
                View Order History
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
